<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Data Dosen'">

          <template v-slot:body>
            <div class="row">
              <div class="col-lg-3">
                <div class="menu">
                  <div class="menu-item" :class="{ 'active': position == 'dataPribadi' ? true : false }"
                    @click="goToSection('dataPribadi')">
                    Data Pribadi
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'pendidikan' ? true : false }"
                    @click="goToSection('pendidikan')">
                    Pendidikan
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'seminar' ? true : false }"
                    @click="goToSection('seminar')">
                    Pelatihan/Seminar
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'karyaIlmiah' ? true : false }"
                    @click="goToSection('karyaIlmiah')">
                    Pelatihan/Karya Ilmiah
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'riwayatJabatan' ? true : false }"
                    @click="goToSection('riwayatJabatan')">
                    Riwayat Jabatan
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'listMahasiswaBimbingan' ? true : false }"
                    @click="goToSection('listMahasiswaBimbingan')">
                    Daftar Mahasiswa Bimbingan
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'riwayat_penugasan' ? true : false }"
                    @click="goToSection('riwayat_penugasan')">
                    Riwayat Penugasan
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'aktivitas_dosen' ? true : false }"
                    @click="goToSection('aktivitas_dosen')">
                    Aktivitas Dosen
                  </div>
                </div>
              </div>
              <div class="col-lg-9">
                <div class="content" ref="dataPribadi">
                  <div class="d-flex justify-content-between">
                    <p class="dosen-title">Data Pribadi</p>
                    <b-button variant="success" class="mb-2 mr-4" @click="getList('data_diri')">
                        <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon>
                    </b-button>
                  </div>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item d-flex justify-content-center mb-6 p-3">
                          <div id="image" class="d-flex justify-content-center flex-column align-items-center">
                            <!-- <div id="preview" style="margin-top: 50%; height: auto;"> -->
                            <div id="preview" class="mb-2">
                              <img v-if="url" :src="url" height="200" width="150" />
                              <div v-else style="height: 200px; width: 150px; background-color: #D9D9D9"></div>
                            </div>
                          </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Pangkat</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.rank }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">KORPS</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.korps }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Prodi Homebase</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.prodi_homebased }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-4 item-title">Nama</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.name }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">NIDN</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.nidn }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">NRP/ NIP</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.nrp }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Jenis Kelamin</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.gender == 'male' ? 'Laki - laki' : 'Perempuan'
                          }}
                          </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Tempat Lahir</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.pob }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Tanggal Lahir</div>
                          <div class="col-lg-8 item-value">: {{ dob }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Email</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.email }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Nomor Ponsel</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.phone }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-4 item-title">Alamat</div>
                          <div class="col-lg-8 item-value">: {{ pribadi.address }}</div>
                        </div>
                        <!-- <div class="row item">
                          <div class="col-lg-4 item-title">Prodi Diajar</div>
                          <div class="col-lg-8 item-value">: {{ prodiDiajar }} </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" ref="pendidikan">
                  <div class="d-flex justify-content-between">
                    <p class="dosen-title">Pendidikan</p>
                    <b-button variant="success" class="mb-2 mr-4" @click="getList('riwayat_pendidikan')">
                        <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon>
                    </b-button>
                  </div>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="pendidikan.headers" :items="pendidikan.data" :loading="pendidikan.isLoading" :loading-text="`Loading... Please wait`">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
                <div class="content" ref="seminar">
                  <p class="dosen-title">Pelatihan / Seminar</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="pelatihan.headers" :items="pelatihan.data">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
                <div class="content" ref="karyaIlmiah">
                  <p class="dosen-title">Penelitian / Karya Ilmiah</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="karyaIlmiah.headers" :items="karyaIlmiah.data">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
                <div class="content" ref="riwayatJabatan">
                  <p class="dosen-title">Riwayat Jabatan</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="riwayatPangkat.headers" :items="riwayatPangkat.desserts">
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
                <div class="content" ref="listMahasiswaBimbingan">
                  <p class="dosen-title">Daftar Mahasiswa Bimbingan</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="listMahasiswaBimbingan.headers" :items="listMahasiswaBimbingan.desserts">
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
                <div class="content" ref="riwayat_penugasan">
                  <div class="d-flex justify-content-between">
                    <p class="dosen-title">Riwayat Penugasan</p>
                    <b-button variant="success" class="mb-2 mr-4" @click="getList('riwayat_penugasan')">
                        <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon>
                    </b-button>
                  </div>
                  <hr class="divider-title" />
                  <div class="content-body">
                      <v-data-table :headers="riwayatPenugasan.headers" :items="riwayatPenugasan.desserts" :loading="riwayatPenugasan.isLoading" :loading-text="`Loading... Please wait`">
                          <template v-slot:item.no="{ item }">
                              {{ item.no }}
                          </template>
                      </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>

                <div class="content" ref="aktivitas_dosen">
                  <div class="d-flex justify-content-between">
                    <p class="dosen-title">Aktivitas Dosen</p>
                    <b-button variant="success" class="mb-2 mr-4" @click="getList('aktivitas_dosen')">
                        <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon>
                    </b-button>
                  </div>
                  <hr class="divider-title" />
                  <div class="content-body">
                      <v-data-table :headers="aktivitasDosen.headers" :items="aktivitasDosen.desserts" :loading="aktivitasDosen.isLoading" :loading-text="`Loading... Please wait`">
                          <template v-slot:item.no="{ item }">
                              {{ item.no }}
                          </template>
                      </v-data-table>
                  </div>
                  <hr class="divider-title" />
                </div>
              </div>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.menu-item.active {
  background-color: #3751E4;
  color: white;
  padding: 10px;
  border-radius: 7px;
  cursor: pointer;
}

.menu-item {
  padding: 10px;
  border-radius: 7px;
  cursor: pointer;
}

.dosen-title {
  // font-family: 'Outfit';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 19px;
  /* identical to box height */
  color: #485377;
  margin-bottom: 6px !important;
}

.content-body {
  padding-top: 10px;
}

.item {
  // font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  /* identical to box height */
  color: #485377;

}

.content {
  margin-bottom: 10px;
}

.divider-title {
  margin: 0;
  border: 1px solid #000000;
}

.row .item {
  margin-top: 0 !important;
}

.form-dosen-header {
  background-color: #3751E4
}

.form-dosen-header span {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  color: white;
}
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios"

export default {
  // props: {
  //   dataDosenString: String
  // },
  data() {
    return {
      url: null,
      file: null,
      pribadi: {
        key: null,
        id_user: null,
        name: null,
        nidn: null,
        nrp: null,
        pob: null,
        dob: null,
        address: null,
        rank: null,
        korps: null,
        gender: null,
        email: null,
        phone: null,
        prodi_homebased: null,
        prodi_diajar: [],
        portrait: null
      },
      position: 'dataPribadi',
      pendidikan: {
        headers: [
          {
            text: "No", value: "no",
            class: 'form-dosen-header'
          },
          {
            text: "Jenjang Studi", value: "education",
            class: 'form-dosen-header'
          },
          {
            text: "Gelar Akademik", value: "degree",
            class: 'form-dosen-header'
          },
          {
            text: "Perguruan Tinggi", value: "institute",
            class: 'form-dosen-header'
          },
          {
            text: "Tahun Lulus", value: "graduation_year",
            class: 'form-dosen-header'
          },
        ],
        data: [],
        isLoading: false,
      },
      pelatihan: {
        headers: [
          {
            text: "No", value: "no",
            class: 'form-dosen-header'
          },
          {
            text: "Nama Pelatihan/Seminar", value: "seminar",
            class: 'form-dosen-header'
          },
          {
            text: "Tahun", value: "year",
            class: 'form-dosen-header'
          },
        ],
        data: [],
      },
      karyaIlmiah: {
        headers: [
          {
            text: "No", value: "no",
            class: 'form-dosen-header'
          },
          {
            text: "Nama Pelatihan/Karya Ilmiah", value: "research",
            class: 'form-dosen-header'
          },
          {
            text: "Tahun", value: "year",
            class: 'form-dosen-header'
          },
        ],
        data: [],
        desserts: [
          {
            no: 1,
            nrp: "Diploma 3",
            nisn: "2022",
          }
        ],
      },
      riwayatPangkat: {
        headers: [
          {
            text: "No", value: "no",
            class: 'form-dosen-header'
          },
          {
            text: "Pangkat", value: "pangkat",
            class: 'form-dosen-header'
          },
          {
            text: "Tahun", value: "tanggal",
            class: 'form-dosen-header'
          },
        ],
        desserts: [],
      },
      listMahasiswaBimbingan: {
        headers: [
          {
            text: "No", value: "no",
            class: 'form-dosen-header'
          },
          {
            text: "Nama Mahasiswa", value: "nrp",
            class: 'form-dosen-header'
          },
          {
            text: "NIP", value: "nisn",
            class: 'form-dosen-header'
          },
          {
            text: "Prodi", value: "prodi",
            class: 'form-dosen-header'
          },
          {
            text: "Tahun Akademik", value: "tahun_akademik",
            class: 'form-dosen-header'
          },
        ],
        desserts: [],
      },
      riwayatPenugasan: {
          headers: [
              { text: "No", value: "no" },
              { text: "Tahun Ajar", value: "tahun" },
              { text: "Prodi", value: "prodi" },
              { text: "Nomor Surat Tugas", value: "nomor_surat" },
              { text: "Prodi Home Base", value: "prodi_homebase" },
              // { text: "Aksi", value: "action" }
          ],
          desserts: [],
          isLoading: false,
      },
      aktivitasDosen: {
          headers: [
              { text: "No", value: "no" },
              { text: "Tahun Ajar", value: "tahun" },
              { text: "Prodi", value: "prodi" },
              { text: "Mata Kuliah", value: "matkul" },
              { text: "Kelas", value: "kelas" },
              { text: "Jumlah Pertemuan", value: "jumlah_pertemuan" },
              // { text: "Aksi", value: "action" }
          ],
          desserts: [],
          isLoading: false,
      },
    }
  },
  components: {
    KTCodePreview,
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Lihat Profil Dosen" }
    ]);
    await this.getdataDiri();
    await this.loadData();

  },
  methods: {
    goToSection(value) {
      let element = this.$refs[value];
      let top = element.offsetTop;
      this.position = value
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    
    async loadData(){
      var data1 = this.getEducationData();
      var data2 = this.getSeminarData();
      var data3 = this.getResearchData();
      var data4 = this.getRiwayatPangkat();
      var data5 = this.getDataPenugasan();
      var data6 = this.getDataAktivitas();

      await Promise.all([data1,data2,data3,data4,data5,data6])
    },

    async getdataDiri(){
      if (this.dataDosen.key === "") {
        this.pribadi.portrait = null
        this.pribadi.key = null
        this.pribadi.name = null
        this.pribadi.nidn = null
        this.pribadi.nrp = null
        this.pribadi.pob = null
        this.pribadi.dob = null
        this.pribadi.address = null
        this.pribadi.rank = null
        this.pribadi.gender = null
        this.pribadi.email = null
        this.pribadi.phone = null
        this.pribadi.prodi_homebased = null
        this.pribadi.prodi_diajar = null
      } else {
        const result = await axios.get(`master/lecturer/${this.dataDosen.key}/detail/`)
        if (result.data.data[0].portrait === undefined || result.data.data[0].portrait === null) {
          this.url = process.env.BASE_URL + "media/users/default.png";
        } else if (result.data.data[0].portrait != "") {
          this.url = this.$endpoint + 'uploads/lecturer_portrait/' + result.data.data[0].portrait
        }
        this.file = result.data.data[0].portrait
        this.pribadi.portrait = result.data.data[0].file
        this.pribadi.key = result.data.data[0].key
        this.pribadi.id_user = result.data.data[0].id_user
        this.pribadi.name = result.data.data[0].name
        this.pribadi.nidn = result.data.data[0].nidn
        this.pribadi.nrp = result.data.data[0].nrp
        this.pribadi.pob = result.data.data[0].place_of_birth
        this.pribadi.dob = result.data.data[0].date_of_birth
        this.pribadi.address = result.data.data[0].address
        this.pribadi.rank = result.data.data[0].rank
        this.pribadi.korps = result.data.data[0].korps
        this.pribadi.gender = result.data.data[0].gender
        this.pribadi.email = result.data.data[0].email
        this.pribadi.phone = result.data.data[0].phone
        this.pribadi.prodi_homebased = result.data.data[0].nama_prodi
        this.pribadi.prodi_diajar = result.data.data[0].prodi_diajar;
        // result.data.data[0].prodi_diajar.forEach(element => this.pribadi.prodi_diajar.push(element.key));
      }
    },

    async getEducationData() {
      try {
        const result = await axios.get(`master/lecturer-education/${this.dataDosen.key}/detail-by-lecturer-id/`)

        if (result.data.meta.code == 200) {
          this.pendidikan.data = result.data.data
        }
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async getSeminarData() {
      try {
        const result = await axios.get(`master/lecturer-seminar/${this.dataDosen.key}/detail-by-lecturer-id/`)

        if (result.data.meta.code == 200) {
          this.pelatihan.data = result.data.data
        }
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async getResearchData() {
      try {
        const result = await axios.get(`master/lecturer-research/${this.dataDosen.key}/detail-by-lecturer-id/`)

        if (result.data.meta.code == 200) {
          this.karyaIlmiah.data = result.data.data
        }
      } catch (err) {
        this.$swal(`Failed`);
      }
    },
    
    async getRiwayatPangkat() {
      try {
        const result = await axios.get(`master/lecturer-history/${this.dataDosen.key}/detail-by-lecturer-id/`)

        result.data.data.map((pang, index) => {
          let obj = {
            no: index+1,
            pangkat: pang.nama_pangkat,
            tanggal: pang.tahun_terbit
          };

          this.riwayatPangkat.desserts.push(obj);
        })
      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async getProdiDiajarOptions(prodi_id) {
      await axios.get('master/study-programs')
        .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              if (e.key != prodi_id) {
                var object = { "id": e.key, "text": e.program_name }
                this.prodiDiajarOptions.push(object);
              }
              return index > e.length;
            });
          }
        })
    },
    async getDataPenugasan() {
        try {
            if (this.riwayatPenugasan.desserts) {
                this.riwayatPenugasan.desserts = [];
            }
            this.riwayatPenugasan.isLoading = true
            // const startTime = Date.now();
            // const result = await axios.get(`master/penugasan-dosen/get-penugasan-dikti/${this.pribadi.key}`)
            const result = await axios.get(`master/penugasan-dosen/riwayat-penugasan/matkul/${this.pribadi.key}`)
            const tugas = [];
            // const totalItems = result.data.data.length;
            await result.data.data.map(async(penugasan, index) => {
                // let loadingPercentages = Math.floor(((index + 1) / totalItems) * 100);
                // this.loadingPercentage = loadingPercentages;
                let penugasans = {
                    key: penugasan.id_dosen,
                    no: index+1,
                    tahun: penugasan.nama_tahun_ajaran,
                    prodi: penugasan.nama_program_studi,
                    nomor_surat: penugasan.nomor_surat_tugas,
                    prodi_homebase: penugasan.nama_program_studi
                };
                tugas.push(penugasans);
            })
            // const elapsedTime = new Date() - startTime;
            // If the elapsed time is less than a certain threshold, wait to reach the threshold
            // if (elapsedTime < 5000) {
            //     await new Promise(resolve => setTimeout(resolve, 5000 - elapsedTime));
                this.riwayatPenugasan.desserts = tugas;
            // }
            this.riwayatPenugasan.isLoading = false
        } catch (err) {
            this.$swal(`Failed`);
        }
    },
    async getDataAktivitas() {
        try {
            if (this.aktivitasDosen.desserts) {
                this.aktivitasDosen.desserts = [];
            }
            this.aktivitasDosen.isLoading = true
            // const startTime = Date.now();
            const result = await axios.get(`master/lecturer/aktivitas/get-dikti/${this.pribadi.key}`)
            const aktiv = [];
            result.data.data.map((aktif, index) => {
                let aktivitas = {
                        key: aktif.id_dosen,
                        no: index + 1,
                        tahun: aktif.nama_periode,
                        prodi: aktif.nama_program_studi,
                        matkul: aktif.nama_mata_kuliah,
                        kelas: aktif.nama_kelas_kuliah,
                        jumlah_pertemuan: aktif.rencana_minggu_pertemuan,
                };
                // this.aktivitasDosen.desserts.push(aktivitas);
                aktiv.push(aktivitas);
            })
            // const elapsedTime = new Date() - startTime;
            // If the elapsed time is less than a certain threshold, wait to reach the threshold
            // if (elapsedTime < 5000) {
            //     await new Promise(resolve => setTimeout(resolve, 5000 - elapsedTime));
                this.aktivitasDosen.desserts = aktiv;
            // }
            this.aktivitasDosen.isLoading = false
        } catch (err) {
            this.$swal(`Failed`);
        }
    },
    async getList(name){
        if (name === 'data_diri') {
            let obj = {
              portrait: null,
              key: null,
              name: null,
              nidn: null,
              nrp: null,
              pob: null,
              dob: null,
              address: null,
              rank: null,
              gender: null,
              email: null,
              phone: null,
              prodi_homebased: null,
              prodi_diajar: null,
            };
            this.pribadi = {...this.pribadi, ...obj};
            this.getdataDiri()
        }else if (name === 'riwayat_pendidikan') {
            this.pendidikan.data = []
            this.pendidikan.isLoading = true;
            let result = await axios.get(`master/lecturer-education/get-from-dikti/${this.pribadi.nidn}/non-dikti`)
            if (result.data.meta.code == 200) {
              this.getEducationData();
              this.pendidikan.isLoading = false;
            }else if(result.data.meta.code == 107){
                this.$swal(`${result.data.meta.message}`);
                this.pendidikan.isLoading = false;
            }
        }else if (name === 'riwayat_penugasan') {
            this.riwayatPenugasan.desserts = [];
            this.riwayatPenugasan.isLoading = true;
            // let result = await axios.get(`master/penugasan-dosen/get-from-dikti/${this.pribadi.key}`)
            // if (result.data.meta.code == 200) {
              await this.getDataPenugasan();
              this.riwayatPenugasan.isLoading = false;
            // }else if(result.data.meta.code == 107){
            //     this.$swal(`${result.data.meta.message}`);
            //     this.riwayatPenugasan.isLoading = false;
            // }
        }else if (name === 'aktivitas_dosen') {
            this.aktivitasDosen.desserts = [];
            this.aktivitasDosen.isLoading = true;
            let result = await axios.get(`master/lecturer/aktivitas/get-from-dikti/${this.pribadi.key}`)
            if (result.data.meta.code == 200) {
              this.getDataAktivitas();
              this.aktivitasDosen.isLoading = false;
            }else if(result.data.meta.code == 107){
                this.$swal(`${result.data.meta.message}`);
                this.aktivitasDosen.isLoading = false;
            }
        }
    },
  },
  computed: {
    dataDosen() {
      return this.$route.params != null ? this.$route.params : null
    },
    dob() {
      const date = new Date(this.pribadi.dob)
      const newDate = `${date.getDate()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`
      return newDate
    },
    prodiDiajar() {
      const diajar = this.pribadi.prodi_diajar.map(x => x.program_name).join(',')

      return diajar
    }
  }
}
</script>